import PreviewSection from '../../PreviewSection'

export default function LeaveHTMLPreviewBaseSection () {}

LeaveHTMLPreviewBaseSection.prototype = new PreviewSection();

LeaveHTMLPreviewBaseSection.prototype.init = function ( columnsStrategy )
{
    PreviewSection.prototype.init.call( this );
    this.columnsStrategy = columnsStrategy;
    return this;
};

LeaveHTMLPreviewBaseSection.prototype.createRowWithMainAndDataCells = function ( rowClassName, mainCellInnerHtml, mainCellClassName )
{
    let row = this.createRow( rowClassName )
    this.addCell( row, mainCellInnerHtml, mainCellClassName );
    this.columnsStrategy.addDataCells( row );
    return row;
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewBaseSection.js